'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Const,
    Piece,
    Player,
    indexOf = [].indexOf;

Const = require('./const');

Piece = require('./piece');

Player = function () {
  var check_kiki, check_tumi, evaluate, is_utifuOute;

  var Player = function () {
    // @depthプロパティはthink,prepareメソッドに渡す引数limitより大きな数値である必要がある
    // 読みの深さとしての属性（@depth）は許容量、実際の読みの深さとして渡すlimit引数の関係
    function Player(turn, human) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;

      _classCallCheck(this, Player);

      this.turn = turn;
      this.human = human;
      this.depth = depth;
      // 以下のメンバー変数は簡易版では未使用
      this.pre_ahead = -1;
      this.pre_select = 4;
      this.preparation = [];
    }

    // prepare: (board, oppo, limit, preValue, pre_ahead = 3) ->
    // 簡易版は省略

    // think: (board, oppo, limit, preValue, priority = [], utifudume = null) ->


    _createClass(Player, [{
      key: 'think',
      value: function think(board, oppo, limit, preValue) {
        var utifudume = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

        var buf, col, dest, dest_piece, i, j, k, kinds, koma, l, lastkoma, lastposi, lastscore, laststatus, len, len1, m, move_piece, n, o, promotion, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, result, results, results1, ret, row, score, shortCut, spare, utifudume_flg, v;
        spare = {};
        lastscore = this.turn === Const.FIRST ? Const.MIN_VALUE : Const.MAX_VALUE;
        lastposi = null;
        lastkoma = null;
        laststatus = null;
        score = 0;
        kinds = [];
        move_piece = null;
        utifudume_flg = null;
        ref = board.pieces;
        for (i = 0, len = ref.length; i < len; i++) {
          koma = ref[i];
          if (koma.turn === this.turn) {
            if (koma.status === Const.Status.MOTIGOMA) {
              if (ref1 = koma.kind(), indexOf.call(kinds, ref1) >= 0) {
                continue;
              }
              kinds.push(koma.kind());
              for (col = j = 1, ref2 = board.cols; 1 <= ref2 ? j <= ref2 : j >= ref2; col = 1 <= ref2 ? ++j : --j) {
                for (row = k = 1, ref3 = board.rows; 1 <= ref3 ? k <= ref3 : k >= ref3; row = 1 <= ref3 ? ++k : --k) {
                  // if priority.length != 0
                  //     continue unless (w for w in choice when row == w.posi[0] && col == w.posi[1])[0]?
                  dest = function () {
                    var l, len1, ref4, results;
                    ref4 = board.pieces;
                    results = [];
                    for (l = 0, len1 = ref4.length; l < len1; l++) {
                      v = ref4[l];
                      if (v.posi != null && v.posi[0] === row && v.posi[1] === col) {
                        results.push(v);
                      }
                    }
                    return results;
                  }();
                  if (dest.length !== 0) {
                    continue;
                  }
                  if (koma.kind() === 'Fu' && is_utifuOute.call(this, board, koma, [row, col])) {
                    if (board.check_utifudume(koma, [row, col])) {
                      utifudume_flg = null;
                      continue;
                    } else {
                      utifudume_flg = koma;
                    }
                  } else {
                    utifudume_flg = null;
                  }
                  move_piece = new Piece.Piece(koma.turn, koma.status, koma.posi);
                  if (board.check_move(koma, [row, col])) {
                    board.move_capture(koma, [row, col]);
                    // 王手放置をチェック
                    // board.make_kiki(oppo.turn)
                    // if (check_kiki.call @, board, oppo) && limit > 0
                    //     if @turn == Const.FIRST
                    //         score = Const.MIN_VALUE
                    //     else
                    //         score = Const.MAX_VALUE
                    // else
                    result = board.gameover();
                    if (limit > 0 && !result) {
                      ret = oppo.think(board, this, limit - 1, lastscore, utifudume_flg);
                      score = ret[2];
                    } else {
                      score = check_tumi.call(this, board);
                    }
                    shortCut = false;
                    if (score > lastscore && this.turn === Const.FIRST || score < lastscore && this.turn === Const.SECOND) {
                      spare["koma"] = lastkoma;
                      spare["posi"] = [].concat(lastposi);
                      spare["score"] = lastscore;
                      spare["status"] = laststatus;
                      lastkoma = koma;
                      lastscore = score;
                      lastposi = [].concat([row, col]);
                      laststatus = koma.status;
                      if (preValue < score && this.turn === Const.FIRST || preValue > score && this.turn === Const.SECOND) {
                        shortCut = true;
                      }
                    }
                  }
                  koma.turn = move_piece.turn;
                  koma.status = move_piece.status;
                  koma.posi = move_piece.posi;
                  if (score >= Const.MAX_VALUE && this.turn === Const.FIRST || score <= Const.MIN_VALUE && this.turn === Const.SECOND) {
                    return [lastkoma, lastposi, lastscore, laststatus, spare];
                  }
                  if (shortCut) {
                    return [lastkoma, lastposi, lastscore, laststatus, spare];
                  }
                }
              }
            } else {
              ref4 = eval("Piece." + koma.kind()).getD(koma.turn, koma.status);
              for (l = 0, len1 = ref4.length; l < len1; l++) {
                v = ref4[l];
                buf = [].concat(koma.posi);
                while (true) {
                  if (!((ref5 = buf[0] + v.xd, indexOf.call(function () {
                    results = [];
                    for (var m = 1, ref6 = board.cols; 1 <= ref6 ? m <= ref6 : m >= ref6; 1 <= ref6 ? m++ : m--) {
                      results.push(m);
                    }
                    return results;
                  }.apply(this), ref5) >= 0) && (ref7 = buf[1] + v.yd, indexOf.call(function () {
                    results1 = [];
                    for (var n = 1, ref8 = board.rows; 1 <= ref8 ? n <= ref8 : n >= ref8; 1 <= ref8 ? n++ : n--) {
                      results1.push(n);
                    }
                    return results1;
                  }.apply(this), ref7) >= 0))) {
                    break;
                  }
                  promotion = false;
                  buf[0] += v.xd;
                  buf[1] += v.yd;
                  dest = function () {
                    var len2, p, ref9, results2;
                    ref9 = board.pieces;
                    results2 = [];
                    for (p = 0, len2 = ref9.length; p < len2; p++) {
                      o = ref9[p];
                      if (o.posi != null && o.posi[0] === buf[0] && o.posi[1] === buf[1]) {
                        results2.push(o);
                      }
                    }
                    return results2;
                  }();
                  if (dest.length !== 0 && dest[0].turn === koma.turn) {
                    break;
                  }
                  move_piece = new Piece.Piece(koma.turn, koma.status, koma.posi);
                  if (dest.length !== 0) {
                    dest_piece = new Piece.Piece(dest[0].turn, dest[0].status, dest[0].posi);
                  }
                  if (board.check_move(koma, buf)) {
                    if (board.check_promotion(koma, buf)) {
                      promotion = true;
                    }
                    board.move_capture(koma, buf);
                    while (true) {
                      // 王手放置をチェック
                      // board.make_kiki(oppo.turn)
                      // if (check_kiki.call @, board, oppo) && limit > 0
                      //     if @turn == Const.FIRST
                      //         score = Const.MIN_VALUE
                      //     else
                      //         score = Const.MAX_VALUE
                      // else
                      result = board.gameover();
                      if (utifudume != null && !result && dest.length !== 0 && dest[0].id === utifudume.id && koma.kind() !== 'Ou') {
                        // console.log(" ===== #{koma.kind()} ===================") if limit <= 0
                        // board.display() if limit <= 0
                        ret = oppo.think(board, this, 0, lastscore, null);
                        if (ret[2] >= Const.MAX_VALUE || ret[2] <= Const.MIN_VALUE) {
                          score = ret[2] * -1;
                        } else {
                          if (limit > 0) {
                            ret = oppo.think(board, this, limit - 1, lastscore, null);
                            score = ret[2];
                          } else {
                            score = check_tumi.call(this, board);
                          }
                        }
                      } else {
                        if (limit > 0 && !result) {
                          ret = oppo.think(board, this, limit - 1, lastscore, null);
                          score = ret[2];
                        } else {
                          score = check_tumi.call(this, board);
                        }
                      }
                      shortCut = false;
                      if (score > lastscore && this.turn === Const.FIRST || score < lastscore && this.turn === Const.SECOND) {
                        spare["koma"] = lastkoma;
                        spare["posi"] = [].concat(lastposi);
                        spare["score"] = lastscore;
                        spare["status"] = laststatus;
                        lastkoma = koma;
                        lastscore = score;
                        lastposi = [].concat(buf);
                        laststatus = koma.status;
                        if (preValue < score && this.turn === Const.FIRST || preValue > score && this.turn === Const.SECOND) {
                          shortCut = true;
                        }
                      }
                      // 駒が成れる場合は成ってからもう一度評価する
                      if (promotion) {
                        promotion = false;
                        koma.status = Const.Status.URA;
                      } else {
                        break;
                      }
                    }
                  }
                  koma.turn = move_piece.turn;
                  koma.status = move_piece.status;
                  koma.posi = move_piece.posi;
                  if (dest.length !== 0) {
                    dest[0].turn = dest_piece.turn;
                    dest[0].status = dest_piece.status;
                    dest[0].posi = dest_piece.posi;
                  }
                  if (score >= Const.MAX_VALUE && this.turn === Const.FIRST || score <= Const.MIN_VALUE && this.turn === Const.SECOND) {
                    return [lastkoma, lastposi, lastscore, laststatus, spare];
                  }
                  if (shortCut) {
                    return [lastkoma, lastposi, lastscore, laststatus, spare];
                  }
                  if (!(dest.length === 0 && v.series)) {
                    break;
                  }
                }
              }
            }
          }
        }
        return [lastkoma, lastposi, lastscore, laststatus, spare];
      }
    }]);

    return Player;
  }();

  ;

  is_utifuOute = function is_utifuOute(board, piece, d_posi) {
    var buf, oppo, oppo_king, v;
    oppo = piece.turn === Const.FIRST ? Const.SECOND : Const.FIRST;
    oppo_king = function () {
      var i, len, ref, results;
      ref = board.pieces;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        v = ref[i];
        if (v.turn === oppo && v.kind() === 'Ou') {
          results.push(v);
        }
      }
      return results;
    }()[0];
    buf = [].concat(d_posi);
    buf[0] += Piece.Fu.getD(piece.turn, piece.status)[0].xd;
    buf[1] += Piece.Fu.getD(piece.turn, piece.status)[0].yd;
    return oppo_king.posi[0] === buf[0] && oppo_king.posi[1] === buf[1];
  };

  check_tumi = function check_tumi(board) {
    var first, i, kings, len, ref, second, v;
    first = 0;
    second = 0;
    kings = function () {
      var i, len, ref, results;
      ref = board.pieces;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        v = ref[i];
        if (v.kind() === 'Ou' && v.turn === Const.FIRST) {
          results.push(v);
        }
      }
      return results;
    }();
    switch (kings.length) {
      case 2:
        return Const.MAX_VALUE;
      case 0:
        return Const.MIN_VALUE;
      default:
        ref = board.pieces;
        for (i = 0, len = ref.length; i < len; i++) {
          v = ref[i];
          if (v.turn === Const.FIRST) {
            first += v.omomi();
          }
          if (v.turn === Const.SECOND) {
            second += v.omomi();
          }
        }
        return first - second;
    }
  };

  check_kiki = function check_kiki(board, oppo) {
    var king, o, v;
    king = function () {
      var i, len, ref, results;
      ref = board.pieces;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        v = ref[i];
        if (v.kind() === 'Ou' && v.turn === this.turn) {
          results.push(v);
        }
      }
      return results;
    }.call(this)[0];
    return function () {
      var i, len, ref, results;
      ref = board.kiki[oppo.turn];
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        o = ref[i];
        if (king.posi[0] === o[0] && king.posi[1] === o[1]) {
          results.push(o);
        }
      }
      return results;
      // return king.posi.toString() in board.kiki[oppo.turn].map (o) -> o.toString()
    }()[0] != null;
  };

  evaluate = function evaluate(board) {
    var first, i, len, ref, second, v;
    first = 0;
    second = 0;
    ref = board.pieces;
    for (i = 0, len = ref.length; i < len; i++) {
      v = ref[i];
      if (v.turn === Const.FIRST) {
        first += v.omomi();
      }
      if (v.turn === Const.SECOND) {
        second += v.omomi();
      }
    }
    return first - second;
  };

  return Player;
}();

module.exports = Player;


//////////////////
// WEBPACK FOOTER
// ./player.coffee
// module id = 311
// module chunks = 0